module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-04.57e216c0.svg";